import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderEDIService = {
  dataSourceConfig(params) {
    var url = "api/SalesOrderEDISSCC";
    return ApiService.createDataSource(url, params);
  },

  async getSalesOrderEDIByCode(salesOrderCode) {
    const requestScreenData = {
      url: "api/SalesOrderEDI",
      top: "1",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getEDICustomerDocumentTypeByCustomerCode(customerCode) {
    const requestScreenData = {
      url: "api/EDICustomerDocumentType",
      filter: `CustomerCode eq '${customerCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async sendSalesOrderEDIPOA(salesOrderCode) {
    var url = `api/Save_SalesOrderSendPOA`;
    var payload = { Code: salesOrderCode };
    return await ApiService.post(url, payload);
  },

  async getTop1Invoice(salesOrderCode) {
    const requestScreenData = {
      url: "api/Invoice",
      top: "1",
      filter: `SalesOrderCode eq '${salesOrderCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async sendSalesOrderEDIASN(salesOrderCode) {
    var url = `api/Save_SalesOrderSendASN`;
    var payload = { Code: salesOrderCode };
    return await ApiService.post(url, payload);
  },

  async sendSalesOrderEDIINV(salesOrderCode) {
    var url = `api/Save_SalesOrderSendINV`;
    var payload = { Code: salesOrderCode };
    return await ApiService.post(url, payload);
  },

  async printSalesOrderSSCC(payload) {
    var url = `api/Save_SalesOrderPrintSSCC`;
    // var payload = { Code: salesOrderCode };
    return await ApiService.post(url, payload);
  },

  async printSSCC(sscc) {
    var url = `api/Save_PrintSSCC`;
    var payload = { SSCC: sscc };
    return await ApiService.post(url, payload);
  },

  async invoiceSalesOrder(salesOrderCode) {
    var url = `api/Save_SalesOrderInvoiceOrder`;
    var payload = { Code: salesOrderCode };
    return await ApiService.post(url, payload);
  },

  async getSSCCHeader(salesOrderCode, params) {
    const requestScreenData = {
      url: "api/SalesOrderEDISSCC",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };

    if (params) {
      if (params.top !== undefined) requestScreenData.top = params.top;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getSSCCDetails(SalesOrderSSCCRecordId) {
    const requestScreenData = {
      url: "api/SalesOrderSSCCDetail",
      filter: `SalesOrderSSCCRecordId eq ${SalesOrderSSCCRecordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBatchLineTotalAllocations(BranchCode, TransactionNo) {
    const requestScreenData = {
      url: "api/ProductBatchAllocation",
      apply: `filter(BranchCode eq '${BranchCode}' and TransactionNo eq ${TransactionNo} and TransactionType eq 'ISO')/aggregate(AllocatedQty with sum as TotalBatchAllocatedQty)`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getSOLinesTotalQty(SalesOrderCode) {
    const requestScreenData = {
      url: "api/SalesOrderDetailCompanyBranch",
      apply: `filter(SalesOrderCode eq ${SalesOrderCode} and IsBatchProduct ne 'No')/aggregate(SalesUMQty with sum as TotalSalesUMQty)`,
    };

    return await ApiService.oDataGet(requestScreenData);

  },

  async SaveProcessEDISalesOrder(salesOrderCode) {
    var url = `api/Save_ProcessEDISalesOrder`;
    var payload = { Code: salesOrderCode };
    return await ApiService.post(url, payload);
  }

};

export { SalesOrderEDIService };
